import { render } from "./MenuButtons.vue?vue&type=template&id=6afe7757"
import script from "./MenuButtons.vue?vue&type=script&lang=js"
export * from "./MenuButtons.vue?vue&type=script&lang=js"

import "./MenuButtons.vue?vue&type=style&index=0&id=6afe7757&lang=css"

import exportComponent from "/Users/gareth/Documents/UW/Global Madison Atlas Final/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__